import React from "react";
import { Globe, Mountain, ScanSearch, Award } from "lucide-react";
import Reveal from "../Reveal";

const PILLARS = [
  {
    Icon: Globe,
    title: "A World of Marble, Curated",
    body:
      "From Italian classics to rare Indian quarries - a tightly edited collection of the world's finest marbles, all in one place.",
  },
  {
    Icon: Mountain,
    title: "Direct From Source",
    body:
      "Sourced from quarries and stockyards in Rajasthan. No intermediaries, no inflated markups.",
  },
  {
    Icon: ScanSearch,
    title: "Verified, Slab by Slab",
    body:
      "Every slab is numbered, photographed, and personally verified by our team before it ever reaches your home.",
  },
  {
    Icon: Award,
    title: "Legacy Meets Innovation",
    body:
      "Three decades of family expertise in the marble trade, brought together by ex-IIT Delhi and ex-BCG entrepreneurs.",
  },
];

export const WhyAurevia = () => {
  return (
    <section
      id="why"
      data-testid="section-why-aurevia"
      className="relative py-16 md:py-24 border-t border-white/5"
    >
      <div className="editorial-container">
        <Reveal className="max-w-3xl mb-10 md:mb-14">
          <div className="flex items-center gap-4 mb-7">
            <span className="h-px w-10 bg-brand-gold/70" />
            <p className="font-sans text-[11px] uppercase tracking-[0.32em] text-brand-gold">
              Why Aurevia
            </p>
          </div>
          <h2
            data-testid="why-aurevia-heading"
            className="font-serif font-light text-balance text-brand-cream leading-[1.02] tracking-tight"
            style={{ fontSize: "clamp(2rem, 4.4vw, 4rem)" }}
          >
            Built on Trust.{" "}
            <span className="italic text-brand-gold/90">Earned by Detail.</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/[0.06]">
          {PILLARS.map((p, i) => {
            const Icon = p.Icon;
            return (
              <Reveal
                key={p.title}
                delay={i * 0.08}
                className="bg-brand-charcoal p-8 md:p-10 lg:p-12 min-h-[280px] md:min-h-[320px] flex flex-col"
                data-testid={`why-pillar-${i}`}
              >
                <Icon
                  className="h-7 w-7 md:h-8 md:w-8 text-brand-gold mb-8 md:mb-10"
                  strokeWidth={1.2}
                />
                <h3 className="font-serif text-xl md:text-[26px] font-light text-brand-cream leading-snug">
                  {p.title}
                </h3>
                <p className="mt-4 md:mt-5 font-sans text-sm md:text-[15px] text-brand-cream/60 leading-relaxed">
                  {p.body}
                </p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyAurevia;
